export default __webpack_public_path__ + "static/media/ocr-a-bt.4791fe4b.ttf";